<template>
  <SoDialog
    v-model="value"
    :max-width="500"
    card-title="Customer Checks"
    data-testid="customer-checks-modal"
  >
    <ul class="customer-checks__list">
      <li>
        If the customer has a 3-phase electricity meter escalate the contact to
        'Bookings External' who can book a specialist smart meter install.
      </li>
    </ul>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"

  export default defineComponent({
    components: {
      SoDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>

<style scoped>
  .customer-checks__list {
    list-style-position: outside;
    margin-left: 12px;
  }
</style>
